'use strict';
angular.module("Khayrokom")
    .config(['$stateProvider', '$urlRouterProvider', '$locationProvider', function ($stateProvider, $urlRouterProvider, $locationProvider) {
        $stateProvider
            .state('home', {
                url: '/home',
                template: require('../../views/home.html'),

                 controller: "MainController"

            })
            .state('service', {
                url: '/service',
                template: require('../../views/template.html'),
                 controller: "MainController"
            })
            .state('news', {
                url: '/news',
                template: require('../../views/news.html'),
                 controller: "MainController"
            })
            .state('video', {
                url: '/video',
                template: require('../../views/video.html'),
                 controller: "MainController"
            })
            .state('consulting', {
                url: '/consulting',
                template: require('../../views/consulting.html'),
                 controller: "MainController"
            })
            .state('staff', {
                url: '/staff',
                template: require('../../views/staff.html'),
                 controller: "MainController"
            }).state('article', {
            url: '/article',
            template: require('../../views/article.html')
        }).state('bio', {
            url: '/bio',
            template: require('../../views/biography.html'),

             controller: "MainController"
        }).state('aboutUs', {
            url: '/aboutUs',
            template: require('../../views/about-us.html'),

             controller: "MainController"
        }).state('structure', {
            url: '/structure',
            template: require('../../views/structure.html'),

             controller: "MainController"
        });
        $urlRouterProvider.otherwise("/home");
        $locationProvider.hashPrefix('');
    }]);





// WEBPACK FOOTER //
// ./js/app/app.router.js